import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedCategories($(window));
		Vegas.windowScroll($(window));
		Vegas.forms();
		Vegas.showMobileSearch();
		Vegas.clones();
		//Vegas.changeSliderCover();

		new VGLawCookie();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedCategories($self);
		Vegas.windowScroll($self);
	},

	onResize: function () {
		Vegas.windowScroll($(window));
		//Vegas.changeSliderCover();
	}
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	forms: function () {
		$('.form-vegas').vegasFormSender({
			beforeSend: function (form) {
				AlertFormSender.Action.beforeSend(form);
			},
			success: function (data, form) {
				AlertFormSender.Action.success(data.msg, form);
			},
			error: function (msg, form) {
				AlertFormSender.Action.error(msg, form);
			},
			validate: function (form, errors) {
				AlertFormSender.Action.validate(errors, form);
			}
		});
	},

	enablePlugins: function () {
		// vg nav
		$('.vg-nav').vegasMenu({
			toggle: '<i class="fa fa-chevron-down"></i>'
		})

		// Tooltip
		$('[data-toggle=tooltip], .vg-tooltip').tooltip();

		// Input mask
		$('[data-mask="phone"]').inputmask('8 (999) 999-99-99', {clearIncomplete: true, showMaskOnHover: true}).on('paste', function (e) {
			$(this).val(normalize_phone_inputmask(e.originalEvent.clipboardData.getData('text')));
			return false;
		}).on('change', function () {
			$(this).val(normalize_phone_inputmask($(this).val()));
		});
		$('.input-mask-card').inputmask('9999 9999 99999', {"clearIncomplete": true});

		// Scrollbar
		let $scrollbarNav = $('.scrollbar-inner');
		if ($scrollbarNav.length) {
			$scrollbarNav.scrollbar();
		}
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		OwlVegas.init('owl-carousel');
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	windowScroll: function ($self) {},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedCategories: function ($self) {
		let $sticky = $('.vg-shop-categories--home'),
			scroll = $self.scrollTop(),
			offset = $('header').height();

		if (scroll > offset) {
			$sticky.addClass('is-fixed');
		} else {
			$sticky.removeClass('is-fixed');
		}
	},

	showMobileSearch() {
		$('[data-toggle=search]').click(function () {
			let $search = $('.vg-header-search');

			if ($search.hasClass('show')) {
				$search.removeClass('show');
			} else {
				$search.addClass('show');

				let $input = $search.find('input[name=search]');
				$input.focus();
			}

			return false;
		});
	},

	clones: function () {
		if (window.innerWidth < 991) {
			let $obj_clone = $('.vg-shop-filters');
			if($obj_clone.length) {
				$obj_clone.clone().detach();
				$('.vg-shop-filters--clone').append($obj_clone)
			}
		}
	},

	changeSliderCover: function () {
		let slide = $('.vg-slider .slide');
		slide.each(function(ind, el) {
			let slideBg = '';
			if (window.innerWidth <= 320 && $(el).attr('data-bg320')){
				slideBg = $(el).attr('data-bg320');
			} else if (window.innerWidth <= 480 && $(el).attr('data-bg480')){
				slideBg = $(el).attr('data-bg320');
			} else if (window.innerWidth <= 800 && $(el).attr('data-bg800')){
				slideBg = $(el).attr('data-bg800');
			} else if (window.innerWidth <= 1024 && $(el).attr('data-bg1024')){
				slideBg = $(el).attr('data-bg1024');
			} else {
				slideBg = $(el).attr('data-bg');
			}

			$(el).css('background-image', 'url('+slideBg+')');
		});

	}
};
